<template>
  <div class="productSort">
    <form @submit.prevent="submitForm">
      <div class="header acea-row row-center-wrapper" ref="header">
        <div class="acea-row row-between-wrapper input">
          <span class="iconfont icon-sousuo"></span>
          <input type="text" placeholder="搜索商品信息" v-model="search" />
        </div>
      </div>
    </form>
    <div class="aside">
      <div
        class="item acea-row row-center-wrapper"
        :class="index === navActive ? 'on' : ''"
        v-for="(item, index) in category"
        :key="index"
        @click="asideTap(index)"
      >
        <span>{{ item.cate_name }}</span>
      </div>
    </div>
    <div class="conter">
      <van-tabs v-model="activeName" swipe-threshold="2" scrollspy sticky @scroll="scrollTabs">
        <van-tab
          :title="item.cate_name"
          :name="index"
          v-for="(item, index) in productList"
          :key="index"
        >
          <div>
            <div
              style="color:gray;font-weight:bold;line-height:0.95rem;margin:0 auto;text-align:center"
            >——{{item.cate_name}}——</div>
            <div v-for="(item2, index2) in item.productList" :key="index2" @click="goDetail(item2)">
              <img v-lazy="item2.image" class="pic-img" />
              <div class="title-name">{{ item2.store_name }}</div>
              <div class="price">￥{{item2.price}}</div>
              <div class="sales">已售{{item2.sales}}件</div>
              <div
                class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"
                style="margin-left:4.5rem;margin-top:-7%;width:0.7rem"
                @click.stop="joinCart(item2)"
              ></div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <Product-window1 v-on:changeFun="changeFun" :attr="attr" @joincar="joincar"></Product-window1>
  </div>
</template>
<script>
import { goShopDetail } from "@libs/order";
import debounce from "lodash.debounce";
import ProductWindow1 from "@components/ProductWindow1";
import { mapGetters } from "vuex";
import {
  getCategory,
  getProductslistall,
  getProductDetail,
  postCartAdd,
  getCartCount
} from "@api/store";
import { trim } from "../../utils";
export default {
  name: "GoodsClass",
  components: {
    ProductWindow1
  },
  props: {},
  data: function() {
    return {
      category: [],
      productList: [],
      navActive: 0,
      search: "",
      lock: false,
      activeName: "first",
      active: 1,
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {}
      },
      isOpen: false, //是否打开属性组件
      productValue: [],
      id: 0,
      storeInfo: {},
      couponList: [],
      attrTxt: "请选择",
      attrValue: "",
      cart_num: 1 //购买数量
    };
  },
  watch: {
    "$route.params.pid": function(n) {
      if (n) {
        this.activeCateId(n);
      }
    }
  },
  computed: {
    ...mapGetters(["isLogin"])
  },
  mounted: function() {
    // document.addEventListener("scroll", this.onScroll, false);
    this.loadCategoryData();
    document
      .getElementsByClassName("van-sticky")[0]
      .classList.add("van-sticky--fixed");
  },
  methods: {
    activeCateId(n) {
      let index = 0;
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index);
      }
    },
    loadCategoryData() {
      getCategory().then(res => {
        this.category = res.data;
        this.$nextTick(() => {
          if (this.$route.params.pid) {
            this.activeCateId(this.$route.params.pid);
          } else {
            // this.onScroll();
            this.getProductslistall(this.category[0].id);
          }
        });
      });
    },
    getProductslistall(sid) {
      getProductslistall(sid).then(res => {
        this.productList = res.data;
      });
    },
    submitForm: function() {
      var val = trim(this.search);
      if (val) {
        this.$router.push({
          path: "/goods_list",
          query: { s: val }
        });
        setTimeout(() => (this.search = ""), 500);
      }
    },
    asideTap(index) {
      this.getProductslistall(this.category[index].id);
      // this.active = index
      // console.log(index)
      // const top =
      //   this.$refs.title[index].offsetTop -
      //   this.$refs.header.offsetHeight -
      //   window.scrollY;

      // this.lock = true;

      // window.scrollBy({ top, left: 0, behavior: "smooth" });
      this.navActive = index;
    },
    /*onScroll: debounce(function() {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
        { scrollY } = window,
        titles = this.$refs.title;
      titles &&
        titles.reduce((initial, title, index) => {
          if (
            !document.querySelector("#title0") &&
            !document.querySelector("#title1") &&
            !document.querySelector("#title2")
          ) {
            return;
          }
          if (initial) return initial;
          if (scrollY + headerHeight < title.offsetTop + title.offsetHeight) {
            initial = true;
            this.navActive = index;
          }
          return initial;
        }, false);
    }, 500),*/
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
    //  点击加入购物车按钮
    joinCart: function(item2) {
      this.id = item2.id;
      this.productCon();
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function(opt) {
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    //产品详情接口；
    productCon: function() {
      let that = this;
      getProductDetail(that.id)
        .then(res => {
          that.$set(that, "storeInfo", res.data.storeInfo);
          that.$set(that.attr, "productAttr", res.data.productAttr);
          that.$set(that, "productValue", res.data.productValue);
          that.DefaultSelect();
          // this.goCat(0);
          //打开属性
          if (that.attrValue) {
            //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
            that.attr.cartAttr = !that.isOpen ? true : false;
          } else {
            if (that.isOpen) that.attr.cartAttr = true;
            else that.attr.cartAttr = !that.attr.cartAttr;
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
    },
    //默认选中属性；
    DefaultSelect: function() {
      let productAttr = this.attr.productAttr,
        value = [];
      for (var key in this.productValue) {
        if (this.productValue[key].stock > 0) {
          value = this.attr.productAttr.length ? key.split(",") : [];
          break;
        }
      }
      for (let i = 0; i < productAttr.length; i++) {
        this.$set(productAttr[i], "index", value[i]);
      }
      //sort();排序函数:数字-英文-汉字；
      let productSelect = this.productValue[value.sort().join(",")];
      if (productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", value.sort().join(","));
        this.$set(this, "attrTxt", "已选择");
      } else if (!productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      } else if (!productSelect && !productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", this.storeInfo.stock);
        this.$set(
          this.attr.productSelect,
          "unique",
          this.storeInfo.unique || ""
        );
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    },
    //购物车；
    ChangeCartNum: function(changeValue) {
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length)
        productSelect = this.attr.productSelect;
      //无属性值即库存为0；不存在加减；
      if (productSelect === undefined) return;
      let stock = productSelect.stock || 0;
      let num = this.attr.productSelect;
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > stock) {
          this.$set(this.attr.productSelect, "cart_num", stock);
          this.$set(this, "cart_num", stock);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    //打开属性插件；
    selecAttrTap: function() {
      this.attr.cartAttr = true;
      this.isOpen = true;
    },
    // 窗口关闭
    changeattr: function(msg) {
      this.attr.cartAttr = msg;
      this.isOpen = false;
    },
    //选择属性；
    ChangeAttr: function(res) {
      let productSelect = this.productValue[res];
      if (productSelect) {
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", res);
        this.$set(this, "attrTxt", "已选择");
      } else {
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    },
    // 点击加入购物车事件
    joincar(data) {
      if (data) {
        this.goCat(0);
      }
    },
    // 加入购物车；
    goCat: function(news) {
      let that = this,
        productSelect = that.productValue[this.attrValue];
      //打开属性
      if (that.attrValue) {
        //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
        that.attr.cartAttr = !that.isOpen ? true : false;
      } else {
        if (that.isOpen) that.attr.cartAttr = true;
        else that.attr.cartAttr = !that.attr.cartAttr;
      }
      //只有关闭属性弹窗时进行加入购物车
      // if (that.attr.cartAttr === true && that.isOpen === false)
      //   return (that.isOpen = true);
      if (
        !this.attr.productSelect.cart_num ||
        parseInt(this.attr.productSelect.cart_num) <= 0
      )
        return that.$dialog.toast({ mes: "请输入购买数量" });
      //如果有属性,没有选择,提示用户选择
      if (
        that.attr.productAttr.length &&
        productSelect === undefined &&
        that.isOpen === true
      )
        return that.$dialog.toast({ mes: "产品库存不足，请选择其它" });
      let q = {
        productId: that.id,
        cartNum: that.attr.productSelect.cart_num,
        new: news,
        uniqueId:
          that.attr.productSelect !== undefined
            ? that.attr.productSelect.unique
            : ""
      };
      postCartAdd(q)
        .then(function(res) {
          that.isOpen = false;
          that.attr.cartAttr = false;
          if (news) {
            that.$router.push({ path: "/order/submit/" + res.data.cartId });
          } else {
            that.$dialog.toast({
              mes: "添加购物车成功",
              callback: () => {
                that.getCartCount(true);
              }
            });
          }
        })
        .catch(res => {
          that.isOpen = false;
          return that.$dialog.toast({ mes: res.msg });
        });
    },
    //获取购物车数量
    getCartCount: function(isAnima) {
      let that = this;
      const isLogin = that.isLogin;
      if (isLogin) {
        getCartCount({ numType: 0 }).then(res => {
          that.CartCount = res.data.count;
          that.$store.dispatch("carNum", { carNum: res.data.count });
          //加入购物车后重置属性
          if (isAnima) {
            that.animated = true;
            setTimeout(function() {
              that.animated = false;
            }, 500);
          }
        });
      }
    },
    // 滚动事件
    scrollTabs({ scrollTop, isFixed }) {
      console.log(scrollTop, isFixed);
      document
        .getElementsByClassName("van-sticky")[0].parentElement.style.height = ''
      document
        .getElementsByClassName("van-sticky")[0]
        .classList.add("van-sticky--fixed");
    }
  },
  beforeDestroy: function() {
    // document.removeEventListener("scroll", this.onScroll, false);
  },
  handleClick(tab, event) {
    console.log(tab, event);
  }
};
</script>
<style lang="scss">
.pic-img {
  width: 2rem;
  height: 2rem;
  padding-top: 0.3rem;
}
.title-name {
  width: 40%;
  margin-top: -1.65rem;
  float: left;
  margin-left: 2.4rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.price {
  color: red;
  font-weight: bold;
  margin-left: 2.4rem;
  margin-top: -1rem;
  font-size: 0.35rem !important;
}
.sales {
  color: gray;
  font-size: 0.25rem !important;
  margin-left: 2.4rem;
}
.conter {
  width: 100%;
  padding-top: 0.95rem !important;
  margin-left: 0 !important;
  padding-left: 1.8rem !important;
}
.van-sticky--fixed {
  top: 0.95rem;
  left: 1.8rem;
}
.van-tab__pane,
.van-tab__pane-wrapper {
  padding-top: 0.95rem;
}
</style>